module.exports = __webpack_public_path__ + "static/media/vocabulary.c7527d8b.png";